import React from "react";
import "./index.css";
import "./App.scss";

import Header from "./components/Header.jsx";
import Hero from "./components/Hero.jsx";
import About from "./components/About.jsx";
import WhyUs from "./components/WhyUs.jsx";
import CountdownSection from "./components/CountdownSection";
import Services from "./components/ServiceArea.jsx";
import WhatYouGet from "./components/WhatYouGet.jsx";
import Gallery from "./components/Gallery.jsx";
import Testimonials from "./components/Testimonials.jsx";
import Pricing from "./components/Pricing.jsx";
import FAQ from "./components/FAQ.jsx";
import Contact from "./components/ContactForm.jsx";
import Footer from "./components/Footer.jsx";
import WhatsAppButton from "./components/FloatingWhatsApp.jsx";

function App() {
  return (
    <>
      {/* 🧭 Tambahkan Header di paling atas */}
      <Header />

      {/* 🏠 1. Hero - Fokus headline & CTA pertama */}
      <Hero />

      {/* 🚚 6. Services */}
      <Services />

       {/* 💸 10. Pricing */}
      <Pricing />

      {/* 🕌 2. Countdown Section */}
      <CountdownSection />

      {/* 💖 3. About */}
      <About />

      {/* 🌟 4. WhyUs */}
      <WhyUs />

      {/* 🎁 7. WhatYouGet */}
      <WhatYouGet />

      {/* 📸 8. Gallery */}
      <Gallery />

      {/* 💬 9. Testimonials */}
      <Testimonials />

      {/* ❓ 12. FAQ */}
      <FAQ />

      {/* 📞 13. Contact */}
      <Contact />

      {/* ⚓ 14. Footer */}
      <Footer />

      {/* 💬 15. WhatsApp Floating Button */}
      <WhatsAppButton />
    </>
  );
}

export default App;
